<h1 class="mt-8">{{ 'LOGIN.SSO.SSO_ERROR_TITLE' | translate }}</h1>
<p class="text-md mb-0 mt-8">
  {{ 'LOGIN.SSO.SSO_ERROR_DESCRIPTION' | translate }}
</p>

<div class="text-md font-semi-bold my-40">
  <p class="mb-0">
    {{ 'LOGIN.SSO.SSO_ERROR_CONTENT' | translate }}
  </p>
  <p
    class="mb-0"
    [innerHTML]="'LOGIN.SSO.SSO_ERROR_CONTENT_ONE' | translate : { email: email }"
  ></p>
  <p class="mb-0">
    {{ 'LOGIN.SSO.SSO_ERROR_CONTENT_TWO' | translate }}
  </p>
</div>

<tsq-button
  schema="new-primary"
  kind="secondary"
  size="lg"
  [text]="'LOGIN.SSO.BACK_TO_LOGIN' | translate"
  (clicked)="backToLogin.emit()"
/>
